import axios from '../../common/utils/interceptor';
import { apiUrls, routeMappings, SessionStore } from '../../constants';
import { getCookie, getCurrentLocale } from '../../common/utils/cookies';
import i18n from '../../internationalization/internationalization';
import { LinkApiErrorCodes } from '../../constants/responseEnums';
import { tcPlusCompanySettings } from './../../authentication/utils/tcPlusCompanySettings';
import { projectSettingsProvider } from '../../store/providers/projectSettingsProvider';
import { companySettingsProvider } from '../../store/providers/companySettingsProvider';
import { NavigateFunction } from 'react-router-dom';

export const initTCPlus = async (
  payload: {
    link: string | undefined;
    resetIndicator: boolean;
    assessmentCompletionURL?: string | null;
    assessmentNonCompletionURL?: string | null;
    testLinkURL?: string;
  },
  navigate: NavigateFunction,
): Promise<void> => {
  const { setProjectSettings } = projectSettingsProvider();
  const { setCompanyLogoUrl, setCompanyBranding } = companySettingsProvider();
  try {
    const { data: responseData } = await axios.post(apiUrls.VALIDATE_TC_PLUS_LINK, payload);
    const isBasicFlow = getCookie('BasicFlow') === '1';
    const locale = getCurrentLocale();
    i18n.changeLanguage(locale.toLocaleLowerCase());
    if (responseData) {
      if (responseData.experienceProps)
        sessionStorage.setItem(SessionStore.experienceProps, JSON.stringify(responseData.experienceProps));
      if (responseData.companyLogoUrl) setCompanyLogoUrl(responseData.companyLogoUrl);
      if (responseData.companyBranding) setCompanyBranding(responseData.companyBranding);
      if (responseData.projectSettings) {
        setProjectSettings(responseData.projectSettings);
      }

      // fetch tc plus company settings
      await tcPlusCompanySettings(true);

      if (responseData.loginSuccess) {
        const tcPlusAuthStream = {
          apiSecret: responseData.apiSecret,
          apiToken: responseData.apiToken,
        };
        sessionStorage.setItem(SessionStore.tcPlusAuthStream, JSON.stringify(tcPlusAuthStream));
        if (!isBasicFlow && responseData.productListing)
          sessionStorage.setItem(SessionStore.basicTaskList, JSON.stringify(responseData.productListing));
        if (responseData.assessmentCompletionURL)
          sessionStorage.setItem(SessionStore.tpurlc, responseData.assessmentCompletionURL);
        if (responseData.assessmentNonCompletionURL)
          sessionStorage.setItem(SessionStore.tpurlnc, responseData.assessmentNonCompletionURL);

        sessionStorage.setItem(SessionStore.basicTaskListHurdleIndicator, 'true');

        if (payload.resetIndicator) return;
        navigate({
          pathname: routeMappings['INIT_EXPERIENCE'],
          search: `?link=${payload.link}`,
        });
      } else {
        if (responseData.errorCode === LinkApiErrorCodes.DEADLINE_PASSED) {
          navigate(routeMappings['EXPIRED_LINK']);
        } else if (responseData.errorCode === LinkApiErrorCodes.LOCKDOWN_BROWSER) {
          sessionStorage.setItem(SessionStore.lockdownBrowserURL, responseData.lockdownBrowserURL);
          navigate(routeMappings['SECURE_BROWSER']);
        } else {
          navigate({ pathname: routeMappings['LINK_INVALID'], search: `?errorCode=${responseData.errorCode}` });
        }
      }
    }
  } catch (error) {
    if (error && error.status === 400) {
      navigate(routeMappings['LINK_INVALID']);
    } else {
      navigate(routeMappings['NOT_FOUND']);
    }
  }
};
